import React from 'react';

import { Stripe } from '../../stripe';

export function CardPayment({
  user,
  amount,
  shippingAddress,
  createPayment,
  onPaymentConfirmed,
}) {
  return (
    <Stripe
      key={amount}
      {...{
        user,
        amount,
        shippingAddress,
        createPayment,
        onPaymentConfirmed,
      }}
    />
  );
}
